import { superscript as superscript_1 } from './superscript.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';

import { toggleSuperscript } from 'roosterjs-editor-api';

const superscript: RibbonButton = {
    key: 'superscript',
    title: () => loc(superscript_1),
    imageSrc: require('../svg/superscript.svg'),
    buttonState: formatState =>
        formatState.isSuperscript ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleSuperscript(plugin.getEditor()),
};

export default superscript;
